import React from "react";
import { LegendPayload, LegendValueFormatter } from "recharts";

const propertyLegendFormatter: LegendValueFormatter = (
  value?: LegendPayload["value"]
) => <span style={{ color: "black" }}>{value}</span>;

export default propertyLegendFormatter;
